import { Position } from '../types'

export default function getPointerPosition(e: MouseEvent | TouchEvent): Position {
	return {
		x: 'pageX' in e ? e.pageX : e.changedTouches[0].pageX,
		y: 'pageY' in e ? e.pageY : e.changedTouches[0].pageY,
	}
}
